import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CookieSettingsService {
  private showSettingsSubject = new BehaviorSubject<boolean>(false);
  showSettings$ = this.showSettingsSubject.asObservable();

  openSettings(): void {
    this.showSettingsSubject.next(true);
  }

  closeSettings(): void {
    this.showSettingsSubject.next(false);
  }
}
